module.exports = __webpack_public_path__ + "img/avatar_image_bg.51808049.svg";